"use client";

import { ChevronDown, LayoutGrid } from "lucide-react";
import { useViewSwitcher } from "./useViewSwitcher";
import { useSaveViewControl } from "./useSaveViewControl";
export const VIEW_TRIGGER_CLASS = "h-8 min-w-[180px] max-w-[260px] justify-between gap-2 rounded-full border-border bg-card shadow-none font-normal text-sm";

// The compact trigger's inner content, shared by the dropdown (desktop header)
// and the mobile sheet trigger.
export function ViewSwitcherTriggerInner() {
  const {
    activeName,
    shownCount,
    total
  } = useViewSwitcher();
  const {
    visible: hasUnsavedChanges
  } = useSaveViewControl();
  return <>
      <LayoutGrid className="shrink-0 text-faint-foreground" data-sentry-element="LayoutGrid" data-sentry-source-file="ViewSwitcherTrigger.tsx" />
      <span className="flex-1 truncate text-left">{activeName}</span>
      {hasUnsavedChanges && <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary" />}
      <span className="shrink-0 text-xs text-faint-foreground">
        {shownCount}/{total}
      </span>
      <ChevronDown className="shrink-0 text-faint-foreground" data-sentry-element="ChevronDown" data-sentry-source-file="ViewSwitcherTrigger.tsx" />
    </>;
}